import { baseApi } from '../baseApi'
import { AICopilotApiArg, AICopilotApiResponse, TextSuggestionApiArg, TextSuggestionApiResponse } from './AIApiTypes'


const AIApi = baseApi.injectEndpoints({
  endpoints: (build) => ({

    sendMessage: build.mutation<AICopilotApiResponse, AICopilotApiArg>({
      query: (queryArg) => ({
        url: `/OpenAI/ai-copilot/`,
        method: 'POST',
        body: queryArg.data,
      }),
    }),

    getTextSuggestions: build.mutation<TextSuggestionApiResponse, TextSuggestionApiArg>({
      query: (queryArg) => ({
        url: `/OpenAI/ai-text-suggestion/`,
        method: 'POST',
        body: queryArg.data,
      }),
    }),
 
  }),
})

export const {
  useSendMessageMutation,
  useGetTextSuggestionsMutation,
} = AIApi
